module.exports = __webpack_public_path__ + "img/rooster-animation.219cf47f.gif";